import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import { useAccess, useProfile } from 'hooks';
import { useTranslation } from 'localization';
import { routes } from 'statics';

import { ServiceFormCard, Tabs } from 'components';

import {
  Head,
  //  UserToBroker,
  UserToUser,
} from './components';

const Transfer: React.FC = () => {
  const { t } = useTranslation('page.transfer');
  const navigate = useNavigate();
  const access = useAccess();

  const { data: profile } = useProfile();

  // LD cant access to Transfer page
  React.useEffect(() => {
    if (['LD', 'BROKER'].includes(profile?.role.title || '')) {
      navigate(routes.dashboard.url);
    }
  }, [profile]);

  const withFlowCard = (node: React.ReactElement) => (
    <ServiceFormCard>{node}</ServiceFormCard>
  );

  return (
    <Box w="100%" pt={{ base: 2, lg: 8 }}>
      <Head />
      <Box
        borderTopWidth="1px"
        borderTopColor="rgba(255,255,255,0.08)"
        pt={{ base: 4, lg: 6 }}
        pb={2}
        my={{ base: 0, lg: 4 }}
      >
        <Tabs
          isLazy
          tabData={[
            {
              label: t('tabs.userToUser'),
              content: withFlowCard(<UserToUser />),
              isActive: access.transferService,
            },
            // { label: t('tabs.userToBroker'), content: withFlowCard(<UserToBroker />) },
          ]}
        />
      </Box>
    </Box>
  );
};

export default Transfer;
